// extracted by mini-css-extract-plugin
export var actions = "_uf-4";
export var item = "_uf-1";
export var price = "_uf-3";
export var quantity = "_uf-2";
export var table = "_uf-0";